import { PureComponent, type ReactNode } from "react";

type MainProps = {
  children?: ReactNode;
};

export class Main extends PureComponent<MainProps> {
  render(): ReactNode {
    return (
      <main>
        <div className="container mx-auto">{this.props.children}</div>
      </main>
    );
  }
}
